import {
  examGradeList,
  examGradeAdd,
  examGradeEdit,
  examGradeDelete,
  examGradeDetail,
  examGradeScoreSum,
  examGradeUserNewInfo,
} from '@/api/exam_grade'

export default {
  async examGradeList({ }, data) {
    return examGradeList(data)
  },
  async examGradeAdd({ }, data) {
    return examGradeAdd(data)
  },
  async examGradeEdit({ }, data) {
    return examGradeEdit(data)
  },
  async examGradeDelete({ }, data) {
    return examGradeDelete(data)
  },
  async examGradeDetail({ }, data) {
    return examGradeDetail(data)
  },
  async examGradeScoreSum({ }, data) {
    return examGradeScoreSum(data)
  },
  async examGradeUserNewInfo({ }, data) {
    return examGradeUserNewInfo(data)
  },
}
